(function() {
    'use strict';
    
    // Toggle tooltip on click for mobile devices
    document.addEventListener('DOMContentLoaded', function() {
        const infoButtons = document.querySelectorAll('.info-card__info-btn');
        
        infoButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                
                // Close all other tooltips
                document.querySelectorAll('.info-card__info-btn[aria-expanded="true"]').forEach(function(btn) {
                    if (btn !== button) {
                        btn.setAttribute('aria-expanded', 'false');
                    }
                });
                
                // Toggle current tooltip
                button.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
            });
        });
        
        // Close tooltips when clicking outside
        document.addEventListener('click', function(e) {
            if (!e.target.closest('.info-card__disclaimer')) {
                document.querySelectorAll('.info-card__info-btn[aria-expanded="true"]').forEach(function(btn) {
                    btn.setAttribute('aria-expanded', 'false');
                });
            }
        });
        
        // Close tooltips on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                document.querySelectorAll('.info-card__info-btn[aria-expanded="true"]').forEach(function(btn) {
                    btn.setAttribute('aria-expanded', 'false');
                });
            }
        });
    });
})();
